module.exports = function() {
  return new Worker(__webpack_public_path__ + "08df092f185824ac3c42.worker.js");
};